import React, { useContext, useEffect, useState } from 'react';
import Sidebar from '../Common/Sidebar';
import Footer from '../Common/Footer';
import { GMCContext } from '../../GMCContext';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import Header from '../Common/Header';


export default function Dashbord1() {

    const { formatAddress, formatDateTime, setIsSidebarEnabled, togel, isDarkMode, setIsDarkMode } = useContext(GMCContext);
    const [data, setdata] = useState([]);
    const [totReward, setTotReward] = useState(0);
    const headerHeight = 70; // Example height of header


    const getData = async () => {
        await axios
            .post(process.env.REACT_APP_BACKEND_LINK, {
                method: "admin",
                submethod: "dashd",
                key: process.env.REACT_APP_KEY,
            })
            .then((res) => {
                // console.log("user dash data:", res.data)
                setdata(res.data);
                if (res.data) {
                }
                if (res.data.error) {
                    return "";
                }
            });
    };

    // console.log("data:", data)
    useEffect(() => {
        if ("") {

        }
        getData();
    }, []);

    return (
        <>
            <div id="layout-wrapper">
                <Header />
                <Sidebar />

                {/* Main Content */}
                <div
                    className="main-content" onClick={() => setIsSidebarEnabled((prev) => !prev)}
                    style={{
                        marginTop: `${headerHeight}px`, // Matches header height
                        padding: '20px', // Adds padding around the content
                        minHeight: `calc(100vh - ${headerHeight}px - 50px)`, // Adjust height for footer
                        boxSizing: 'border-box', // Ensures padding is included in height
                    }}
                >
                    <div className="row g-3" style={{ paddingBottom: '20px', marginBottom: '30px' }}>
                        <div className="d-flex justify-content-between align-items-center">
                            {/* Left Section */}
                            <div className="flex-grow-1">
                                <h4 className="fs-16 mb-3">Welcome, Admin!</h4>

                                <div className="d-flex flex-wrap gap-3">
                                    <Link to="/pools" className="custom-btn text-white text-decoration">
                                        Pools
                                    </Link>

                                    <Link to="/top1" className="custom-btn text-white text-decoration">
                                        Top 1 User
                                    </Link>

                                    <Link to="/top100" className="custom-btn text-white text-decoration">
                                        Top 100 Users
                                    </Link>

                                    <Link to="/top1000" className="custom-btn text-white text-decoration">
                                        Top 1000 Users
                                    </Link>
                                </div>
                            </div>

                            {/* Right Section */}
                            <div className="mt-3 mt-lg-0">
                                <form action="javascript:void(0);">
                                    <div className="row g-3 mb-0 align-items-center">
                                        <div className="col-sm-auto">
                                        </div>
                                     
                                    </div>
                                </form>
                            </div>
                        </div>

                        {/* Cards Section */}

                        <div className="col-xl-3 col-md-6">
                            <div className="card card-animate">
                                <div className="card-body">
                                    <div className="d-flex align-items-center">
                                        <div className="flex-grow-1 overflow-hidden">
                                            <p className="text-uppercase fw-medium text-muted text-truncate mb-0">
                                                Total User
                                            </p>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-end justify-content-between mt-4">
                                        <div>
                                            <h4 className="fs-22 fw-semibold ff-secondary mb-4">
                                                <span > {data?.totalusers ? data?.totalusers : "0"}</span>
                                            </h4>
                                            Click on: <Link to="/memberreport" className="text-decoration-underline">See Total User  </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-md-6">
                            <div className="card card-animate">
                                <div className="card-body">
                                    <div className="d-flex align-items-center">
                                        <div className="flex-grow-1 overflow-hidden">
                                            <p className="text-uppercase fw-medium text-muted text-truncate mb-0">
                                                Total Active User
                                            </p>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-end justify-content-between mt-4">
                                        <div>
                                            <h4 className="fs-22 fw-semibold ff-secondary mb-4">
                                                <span > {data?.activeuser ? data?.activeuser : "0"}</span>
                                            </h4>
                                            Click on: <Link to="/memberreport" className="text-decoration-underline">See Total User  </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-md-6">
                            <div className="card card-animate">
                                <div className="card-body">
                                    <div className="d-flex align-items-center">
                                        <div className="flex-grow-1 overflow-hidden">
                                            <p className="text-uppercase fw-medium text-muted text-truncate mb-0">
                                                Total Purchase $
                                            </p>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-end justify-content-between mt-4">
                                        <div>
                                            <h4 className="fs-22 fw-semibold ff-secondary mb-4">
                                                $ <span>{data?.totalstakeD ? Number(data?.totalstakeD).toFixed(2) : "0"}</span>
                                            </h4>
                                            Click on: <Link to="/stakingsidbarreport" className="text-decoration-underline">See Total Purchase</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-md-6">
                            <div className="card card-animate">
                                <div className="card-body">
                                    <div className="d-flex align-items-center">
                                        <div className="flex-grow-1 overflow-hidden">
                                            <p className="text-uppercase fw-medium text-muted text-truncate mb-0">
                                                Total Ecosystem Balance
                                            </p>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-end justify-content-between mt-4">
                                        <div>
                                            <h4 className="fs-22 fw-semibold ff-secondary mb-4">
                                                <span>$ {data?.totalecos ? (data?.totalecos).toFixed(2) : "0"} </span>
                                            </h4>
                                            {/* Click on: <a href="stakingsidbarreport" className="text-decoration-underline">See Total Purchase {process.env.REACT_APP_TICKER || "Not Set"}</a> */}
                                        </div>
                                    </div>                                   
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-md-6">
                            <div className="card card-animate">
                                <div className="card-body">
                                    <div className="d-flex align-items-center">
                                        <div className="flex-grow-1 overflow-hidden">
                                            <p className="text-uppercase fw-medium text-muted text-truncate mb-0">
                                                Pool Reward
                                            </p>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-end justify-content-between mt-4">
                                        <div>
                                            <h4 className="fs-22 fw-semibold ff-secondary mb-4">
                                                $ <span>{data?.poolrew ? parseFloat(data?.poolrew).toFixed(2) : "0"}</span>
                                            </h4>
                                            Click on: <Link to="/levelrewardsidbar" className="text-decoration-underline">See Pool Reward</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-md-6">
                            <div className="card card-animate">
                                <div className="card-body">
                                    <div className="d-flex align-items-center">
                                        <div className="flex-grow-1 overflow-hidden">
                                            <p className="text-uppercase fw-medium text-muted text-truncate mb-0">
                                                Weekly Reward
                                            </p>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-end justify-content-between mt-4">
                                        <div>
                                            <h4 className="fs-22 fw-semibold ff-secondary mb-4">
                                                $ <span>{data?.weekrew ? parseFloat(data?.weekrew).toFixed(2) : "0"}</span>
                                            </h4>
                                            Click on: <Link to="/roisidebar" className="text-decoration-underline">See Weekly Reward</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-md-6">
                            <div className="card card-animate">
                                <div className="card-body">
                                    <div className="d-flex align-items-center">
                                        <div className="flex-grow-1 overflow-hidden">
                                            <p className="text-uppercase fw-medium text-muted text-truncate mb-0">
                                                Team Roi
                                            </p>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-end justify-content-between mt-4">
                                        <div>
                                            <h4 className="fs-22 fw-semibold ff-secondary mb-4">
                                                $ <span>{data?.lrewards ? parseFloat(data?.rorReward).toFixed(2) : "0"}</span>
                                            </h4>
                                            Click on: <Link to="/roiofroi" className="text-decoration-underline">See Team Roi </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-md-6">
                            <div className="card card-animate">
                                <div className="card-body">
                                    <div className="d-flex align-items-center">
                                        <div className="flex-grow-1 overflow-hidden">
                                            <p className="text-uppercase fw-medium text-muted text-truncate mb-0">
                                                Total Pending Withdrawal
                                            </p>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-end justify-content-between mt-4">
                                        <div>
                                            <h4 className="fs-22 fw-semibold ff-secondary mb-4">
                                                $ <span>{data?.pwithdrawlD ? Number(data?.pwithdrawlD).toFixed(2) : "0"}</span>
                                            </h4>
                                            Click on: <Link to="/pendingwithdrwalsidebar" className="text-decoration-underline">See Pending Withdrawal</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-md-6">
                            <div className="card card-animate">
                                <div className="card-body">
                                    <div className="d-flex align-items-center">
                                        <div className="flex-grow-1 overflow-hidden">
                                            <p className="text-uppercase fw-medium text-muted text-truncate mb-0">
                                                Total Withdrawal
                                            </p>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-end justify-content-between mt-4">
                                        <div>
                                            <h4 className="fs-22 fw-semibold ff-secondary mb-4">
                                                $ <span>{data?.withdrawl ? Number(data?.withdrawl).toFixed(2) : "0"}</span>
                                            </h4>
                                            Click on: <Link to="/withdrwalsidebar" className="text-decoration-underline">See Withdrawal Report</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-md-6">
                            <div className="card card-animate">
                                <div className="card-body">
                                    <div className="d-flex align-items-center">
                                        <div className="flex-grow-1 overflow-hidden">
                                            <p className="text-uppercase fw-medium text-muted text-truncate mb-0">
                                                Level Reward
                                            </p>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-end justify-content-between mt-4">
                                        <div>
                                            <h4 className="fs-22 fw-semibold ff-secondary mb-4">
                                                $ <span>{data?.lrewards ? Number(data?.lrewards).toFixed(2) : "0"}</span>
                                            </h4>
                                            Click on: <Link to="/withdrwalsidebar" className="text-decoration-underline">See Level Reward</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <style>{
                `
                    .custom-btn {
                        background: linear-gradient(135deg, #405189, #5b6fc9); /* blue gradient shades */
                        color: #fff;
                        font-size: 16px;
                        font-weight: 600;
                        padding: 12px 32px;
                        border: none;
                        border-radius: 50px; /* pill shape */
                        cursor: pointer;
                        box-shadow: 0 6px 18px rgba(64, 81, 137, 0.4);
                        transition: all 0.3s ease;
                        letter-spacing: 0.5px;
                        position: relative;
                        overflow: hidden;
                    }

                    /* Shine animation effect */
                    .custom-btn::before {
                        content: "";
                        position: absolute;
                        top: 0;
                        left: -75px;
                        width: 50px;
                        height: 100%;
                        background: rgba(255, 255, 255, 0.4);
                        transform: skewX(-25deg);
                        transition: left 0.5s;
                    }

                    .custom-btn:hover::before {
                        left: 125%;
                    }

                    /* Hover */
                    .custom-btn:hover {
                        background: linear-gradient(135deg, #324172, #4a5fb3);
                        box-shadow: 0 8px 20px rgba(64, 81, 137, 0.5);
                        transform: translateY(-2px);
                    }

                    /* Active/Click */
                    .custom-btn:active {
                        transform: translateY(0);
                        box-shadow: 0 4px 10px rgba(64, 81, 137, 0.3);
                    }
                `
            }</style>

            <Footer />
        </>
    );
}
